import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { CalendarScheduleIcon } from '@moia-dev/pace-icons'
import { UpdatesAreaRoutes } from './UpdatesAreaRoutes'

export const UpdatesAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={UpdatesAreaRoutes.route}
      Icon={CalendarScheduleIcon}
    />
  )
}
